import { createRouter, createWebHashHistory } from "vue-router";
import { nextTick } from "vue";
import posthog from "posthog-js";
import { htmlTitleGuard } from "@core/guards/html-title.guard";
import { ETAB_ROUTES } from "@etab/config";
import { isNative } from "@core/plugins/mobile";
import { PosthogManager } from "@etab/managers/posthog.manager";
import { TrackingManager } from "@core/managers/tracking.manager";
import { setupAuthenticationGuard } from "@core/guards/authentication.guard";
import { setupProfileLoadGuard } from "@core/guards/profile-load.guard";
import { DataLayerManager } from "@core/managers/datalayer-manager";
import getRoutes from "./routes";
import { BatchManager } from "@core/plugins/batch/batch.manager";
import { ACTION_PROFILE_INIT, GETTER_PROFILE_GET } from "../stores/types";

const handleScrollBehavior = (to, from, savedPosition) => {
  // we want to always scroll to top if not precised otherwise
  const doNotScrollTop = Object.prototype.hasOwnProperty.call(to.params, "doNotScrollTop");
  if (doNotScrollTop) {
    return null;
  }
  return savedPosition || { left: 0, top: 0 };
};

export default function () {
  const authenticationGuard = setupAuthenticationGuard({
    authHomeRoute: ETAB_ROUTES.smartRedirect.name,
    loginRoute: ETAB_ROUTES.auth.login.name,
  });

  const profileLoadGuard = setupProfileLoadGuard({
    storeAction: ACTION_PROFILE_INIT,
    storeGetter: GETTER_PROFILE_GET,
  });

  const router = createRouter({
    history: createWebHashHistory(process.env.VUE_ROUTER_BASE),
    routes: getRoutes(),
    scrollBehavior: handleScrollBehavior,
  });

  router.beforeEach(authenticationGuard);
  router.beforeEach(profileLoadGuard);
  router.beforeEach(htmlTitleGuard);
  router.beforeEach(DataLayerManager.handleDataLayer("etablissement"));
  router.beforeEach(async (to, from) => {
    if (isNative && BatchManager.batchStarted()) {
      BatchManager.sendEvent({ name: "page_view", route: to });
    }
  });

  // Update Posthog current_url and add firebase event with current url path
  router.afterEach((to, from) => {
    nextTick(() => {
      TrackingManager.addEvent({
        event: "screen_view",
        firebase_screen_class: to.path,
        firebase_screen: to.name,
        path: to.fullPath,
      });
    });
  });

  return router;
}
